/* eslint-disable import/prefer-default-export */
import { uiConstants } from '../constants/uiConstants';

function setPageTitle(name) {
  return (dispatch) => {
    dispatch({ type: uiConstants.SET_PAGE_TITLE, name });
  };
}

export const uiActions = {
  setPageTitle,
};
